(function (ws) {
    'use strict';

    /**
    * The point of this view is to centralize the behaviour of the bundles for
    * quoting and orderentry tables for SBAs.
    */
    ws.views.SbaTable = ws.views.googleAnalytics.extend({
        parentTypes: ['RPB', 'TPB', 'VPSP', 'VPSC', 'SCONTC'],
        childTypes: ['RCB', 'TCB'],
        subscriptionTypes: ['SUBSCRIPTION', 'PER_UNIT_SUBSCRIPTION'],
        blueSkyTypes: ['CONFIGURABLE', 'CONFIGURED_PARENT', 'CONFIGURED_CHILD'],
        annuityTypes: ['FULL_TERM_ITEM'],
        annuityTypesCheckbox: ['FULL_TERM_ITEM', 'FULL_TERM_ITEM_CHILD', 'FULL_TERM_ITEM_PARENT'],
        vpsTypes: ['VPSC', 'SCONTC', 'PER_UNIT_SUBSCRIPTION', 'FULL_TERM_ITEM_CHILD', 'FULL_TERM_ITEM_PARENT'],
        vpsParentTypes: ['VPSP', 'SCONTP'],

        /**
        * A helper method to check if a product is the parent of a bundle
        * @param {Object} product
        */
        isBundleParent: function(product) {
            return _.includes(this.parentTypes, product.type);
        },

        /**
        * A helper method to check if a product is a child in a bundle
        * @param {Object} product
        */
        isBundleChild: function(product) {
            return _.includes(this.childTypes, product.type);
        },

        /**
         * A helper method to check if a product is a VPS
         * @param {Object} product
         */
        isVps: function(product) {
            return _.includes(this.vpsTypes, product.type);
        },

        isBlueSky: function(product) {
            return _.includes(['CONFIGURED_PARENT'], product.type);
        },

        /**
         * A helper method to check if a product is a VPS
         * @param {Object} product
         */
        isVpsParent: function(product) {
            return _.includes(this.vpsParentTypes, product.type);
        },

        /**
        * A helper method to differentiate the parent and child products in a bundle
        * @param {Object} product
        */
        getPartNumberFieldByType: function(product) {
            if (this.isBundleChild(product) || this.isVps(product)) {
                return '<span class="item-bundle-child" style="font-style: italic;font-size: .75rem;">' + product.partNumber + '</span>';
            } else if (this.isBundleParent(product) || this.isVpsParent(product) || this.isAvaya(product) || this.isBlueSky(product) || this.isAnnuity(product)) {
                return '<span class="qut-expand-icon icon-sign_minus item-bundle-parent" data-id="' + product.id + '"></span><span class="item-bundle-parent">' + product.partNumber + '</span>';
            } else {
                return '<a class="tooltip-target">' + product.partNumber + '</a>';
            }
        },

        /**
         * A helper method to check if a product is Avaya
         * @param {Object} product
         */
        isAvaya: function(product) {
            return _.includes(this.subscriptionTypes, product.type);
        },

        /**
         * A helper method to check if a product is Cisco Annuity
         * @param {Object} product
         */
        isAnnuity: function(product) {
            return _.includes(this.annuityTypes, product.type);
        },

        /**
        * Create checkbox input for the first cell of the row
        * @param {Object} product
        * @param {string} isSelected
        */
        getCheckboxForRow: function(product, isSelected) {
            if ($('#hasCreditLine').val() === 'true') {
                return '<input type="checkbox" class="ckp custom-checkbox table-checkbox" disabled /><label class="custom-checkbox-label"></label>';
            } else {
                return (!this.isBundleParent(product)) ? this.buildCheckboxByProduct(product, isSelected) : '';
            }
        },

        /**
        * Create checkbox input for the first cell of the row
        * @param {Object} product
        * @param {string} isSelected
        */
        buildCheckboxByProduct: function(product, isSelected) {
            if (this.subscriptionTypes.includes(product.type) || this.blueSkyTypes.includes(product.type)) {
                return '<input type="checkbox" class="avaya custom-checkbox table-checkbox" disabled><label class="custom-checkbox-label"></label>';
            } else if (this.annuityTypesCheckbox.includes(product.type)) {
                return '<input type="checkbox" class="annuity custom-checkbox table-checkbox" disabled><label class="custom-checkbox-label"></label>';
            } else {
                return '<input id="product-' + product.id + '" type="checkbox" value="' + product.id + '" ' +
                    'class="custom-checkbox table-checkbox sba-product-select" ' +
                    'data-id="' + product.id + '" data-part-number="' + product.partNumber + '"' + isSelected + ' >' +
                    '<label for="product-' + product.id + '" class="custom-checkbox-label"></label>';
            }
        },

        /**
        * Create list of manual SBAs applied
        * @param {Object} product
        */
        getManualSBAsAppliedForRow: function(product, readonly) {
            return (!this.isBundleParent(product)) ? this.buildManualSBAsAppliedForRow(product, readonly) : '';
        },

        /**
        * Build list of manual SBAs applied
        * @param {Object} product
        */
        buildManualSBAsAppliedForRow: function(product, readonly) {
            let highLightSBA = '';

            if (this.mapping) {
                _.each(this.mapping, function (highlight) {
                    if (product.displayEntryNumber === highlight.lineNumber) {
                        _.each(highlight.misMatchData, function (sbaMismatch) {
                            if (sbaMismatch.field === 'sba') {
                                highLightSBA = 'highlightCell';
                            }
                        });
                    }
                });
            }

            return _.map(product.appliedSBAsOnProduct, function (appiledSBA) {
                return (readonly) ?
                '<a>' + appiledSBA + '</a>' :
                '<a data-deal-id="' + appiledSBA + '" data-sba-type="manual" class="' + highLightSBA + '">' + appiledSBA + '</a>';
            }).join(', ');
        },

        /**
        * Create list of automatic SBAs applied
        * @param {Object} product
        */
        getAutomaticSBAsAppliedForRow: function(product) {
            return (!this.isBundleParent(product) && !this.isAvaya(product) && !this.isBlueSky(product)) ? this.buildAutomaticSBAsAppliedForRow(product) : '';
        },

        /**
        * Build list of automatic SBAs applied
        * @param {Object} product
        */
        buildAutomaticSBAsAppliedForRow: function(product) {
            return _.map(product.appliedAutoSBAsOnProduct, function (appiledSBA) {
                return '<a data-deal-id="' + appiledSBA + '" data-sba-type="auto">' + appiledSBA + '</a>';
            }).join(', ');
        }

    });
}(westcon));
